import '../Scss/app.scss';
import components from './config/registry';

// Components
import events from './helpers/events';
import general from './core/general';
import footer from './components/footer';

// Import all
const modules = [general, footer, events];
modules.forEach(module => {
  module();
});
const componentImport = async (el, fileName) => {
  if (!document.querySelector(el) || 'noload' in document.querySelector(el).dataset) return;
  const module = await import(`./${fileName}`);
  // Initialize module
  if (typeof module === 'function') {
    module();
  } else if (typeof module === 'object' && typeof module.default === 'function') {
    module.default();
  }
};
await Promise.all(components.map(({
  el,
  fileName
}) => componentImport(el, fileName)));